import { render, staticRenderFns } from "./VipUserModalDelete.vue?vue&type=template&id=9de1a276"
import script from "./VipUserModalDelete.vue?vue&type=script&lang=js"
export * from "./VipUserModalDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports